import styled, { css } from 'styled-components';
import { mediaQueries } from '../../providers/MediaQueryProvider';
export const Pagination = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: var(--text-secondary);
`;
export const InputForm = styled.form `
  width: 50px;
  margin-right: var(--space-300);
`;
export const IconContainer = styled.div `
  display: flex;
  padding: var(--space-250);
  cursor: pointer;

  ${({ $left }) => $left &&
    css `
      margin-left: var(--space-n250);
      margin-right: var(--space-350);
    `}

  ${({ $right }) => $right &&
    css `
      margin-left: var(--space-350);
      margin-right: var(--space-n250);
    `}

  ${({ $disabled }) => $disabled &&
    css `
      color: var(--text-tertiary);
      cursor: default;
    `}
`;
export const Total = styled.span `
  display: none;
  margin-right: var(--space-600);
  align-items: center;
  gap: var(--space-200);
  color: var(--text-secondary);

  ${mediaQueries.tablet} {
    display: initial;
  }
`;
